<template>
    <v-card flat tile>
        <v-card-text>
            <v-layout v-if="queried.testTypes" row>
                <template v-for="type in queried.testTypes">
                        <v-flex :key="type.uuid" mr-3>
                            <v-badge :color="testCount(type.name) > 0 ? 'red' : 'grey'" overlap >
                                <template v-slot:badge>{{testCount(type.name)}}</template>
                                <v-card class="pa-0" outlined>
                                    <v-btn text  block>
                                        {{type.name}}
                                    </v-btn>
                                    <v-divider></v-divider>
                                    <v-btn @click="addTest(type)" text  x-small tile><v-icon>keyboard_arrow_up</v-icon></v-btn>

                                    <v-btn @click="removeTest(type)" text x-small tile><v-icon>keyboard_arrow_down</v-icon></v-btn>
                                </v-card>
                            </v-badge>
                        </v-flex>
                </template>
            </v-layout>
            <v-progress-linear height="20" v-else indeterminate>Loading test types...</v-progress-linear>
        </v-card-text>
    </v-card>
</template>

<script>
    import recorded from '../Lib/Recorded'
    import RequiredTests from '../Lib/RequireTest';
    export default {
        name: "RequiredTestSelection",
        data: () => ({
            controls:{},
            tests: [],
            form: {

            },
            queried: {
                testTypes: null,
            }
        }),
        props:{
          sample_type:{
              default: null,
          }
        },
        created(){
          this.getTestTypes()
        },
        watch: {
            tests(v){
              this.$emit("selected", v)
             },
            sample_type(v){
               if(v){
                   RequiredTests.tests(v, requiredTests => {
                       console.log(requiredTests, 'required')
                       if(this.queried.testTypes){
                           this.tests = [];
                           for(let i = 0; i < requiredTests.length; i+=1){
                               let test = this.queried.testTypes.filter(v => {return v.name === requiredTests[i]});
                               this.addTest(test[0]);
                           }
                       }
                   });
               }
            }
        },
        methods:{
            async getTestTypes(){
                let response = await recorded.get('/sampleTestTypes');
                let filtered = this.$store.state.filtered_test_types || [];
                if (filtered.length > 0) {
                    this.queried.testTypes = response.data.filter(t => !filtered.includes(t.uuid));
                } else {
                    this.queried.testTypes = response.data;
                }
                if(this.sample_type){
                    this.setTests(this.sample_type)
                }
            },
            addTest(test){
                this.tests.push(test);
            },
            setTests(v){
                RequiredTests.tests(v, requiredTests => {
                    if(this.queried.testTypes){
                        this.tests = [];
                        for(let i = 0; i < requiredTests.length; i+=1){
                            let test = this.queried.testTypes.filter(v => {return v.name === requiredTests[i]});
                            this.addTest(test[0]);
                        }
                    }
                });

            },
            removeTest(test){
                let allOtherTests = this.tests.filter(item => {return item.name !== test.name });
                let removeTest = this.tests.filter(item => {return item.name === test.name });
                removeTest.pop();
                this.tests= allOtherTests.concat(removeTest);
            },
            testCount(name){
                let tests = this.tests.filter(item => {return item.name === name})
                return tests.length
            }
        }
    }
</script>

<style scoped>

</style>
